import {createFileRoute} from '@tanstack/react-router'

import {WorkerDetailsPage} from 'src/assets/workers/worker-details-page'

export const Route = createFileRoute('/_app/workers/$workerId')({
    component: WorkerDetailsRoute,
})

function WorkerDetailsRoute() {
    const {workerId} = Route.useParams()

    return <WorkerDetailsPage workerId={workerId} />
}
